import { TipoCambioSUNAT } from "../../bussines/entities/tipoCambioSUNAT.entity";
import { paramsGetListaTipoCambioSUNAT } from "../../bussines/params/ListaTipoCambioSUNAT.params";
import { ListaTipoCambioSUNATRepository } from "../../bussines/repository/ListaTipoCambioSUNAT.repository";
import { ListaTipoCambioSUNATExpressProvider } from "../providers/ListaTipoCambioSUNAT.provider";

export class ListaTipoCambioSUNATDatasource implements ListaTipoCambioSUNATRepository {
   private ListaTipoCambioSUNATProvider: ListaTipoCambioSUNATExpressProvider;
   constructor(apiKey: string) {
      this.ListaTipoCambioSUNATProvider = new ListaTipoCambioSUNATExpressProvider(apiKey);
   }
   getListaTipoCambioSUNAT(variables: paramsGetListaTipoCambioSUNAT): Promise<TipoCambioSUNAT[]> {
      return this.ListaTipoCambioSUNATProvider.getListaTipoCambioSUNAT(variables);
   }
}